// Avi Cement company locations for map markers
export const AVI_LOCATIONS = [
  {
    id: "head-office",
    label: "Avi Cement Head Office",
    type: "HEAD_OFFICE",
    address: "D1, Jay Tower, Ankur Commercial Center, Ankur Cross Road, Naranpura, Ahmedabad, Gujarat 380013",
    lat: 23.0469,
    lng: 72.5615,
    icon: "HQ",
    color: "#1A1A2E",
  },
  {
    id: "gujarat-plant",
    label: "Gujarat Manufacturing Plant",
    type: "PLANT",
    address: "55, Ranasan GIDC, Mahudi-Vijapur Road, Mahudi, Gujarat 382870",
    lat: 23.385,
    lng: 72.565,
    icon: "P1",
    color: "#C0272D",
  },
  {
    id: "rajasthan-plant",
    label: "Rajasthan Manufacturing Plant",
    type: "PLANT",
    address: "Bhagoron ka Khera, Ghatol, Banswara, Rajasthan 327023",
    lat: 23.62,
    lng: 74.42,
    icon: "P2",
    color: "#F5A623",
  },
];

// Metric Ton ↔ Bags conversion
export const MT_TO_BAGS = 20;
export const bagsToMT = (bags) => bags / MT_TO_BAGS;
export const mtToBags = (mt) => mt * MT_TO_BAGS;
export const formatDualQuantity = (qty, unit) => {
  if (unit === "BAG" || unit === "bags") {
    const mt = qty / MT_TO_BAGS;
    return `${qty} Bags (${mt.toFixed(2)} MT)`;
  }
  const bags = qty * MT_TO_BAGS;
  return `${qty} MT (${bags} Bags)`;
};

// Open Google Maps directions
export const openDirections = (lat, lng) => {
  window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, "_blank");
};

// Open Google Maps pin
export const openMapPin = (lat, lng) => {
  window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
};
